import { MarkerType } from 'reactflow';

export const LARGE_ARROW_MARKER = { 
    type: MarkerType.ArrowClosed, 
    width: 25, 
    height: 25 
};
